import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CalendarView } from 'angular-calendar';

import { AppComponent } from '../../app.component';
import { BaseService } from '../../shared/services/base.service';

import { CalendarFilter } from '../models/calendar.filter';
import { Crew } from '../../shared/models/crew.interface';
import { CalendarSummary } from '../models/calendar.interface';

@Injectable()

export class CalendarService extends BaseService {

  constructor(private appComponent: AppComponent, protected http: HttpClient, router: Router) {
    super(http, router);
  }

  getCalendar(viewDate: Date, calendarView: CalendarView, filter: CalendarFilter): Observable<CalendarSummary> {
    let params = new HttpParams();

    if (filter.crew) params = params.append('crewId', (filter.crew as Crew).crew_ID.toString());
    if (filter.quoteId) params = params.append('quoteId', filter.quoteId.toString());

    return this.httpGet<CalendarSummary>("/workOrder/calendar/" + calendarView + '/' + viewDate.toISOString() +
      '?' + params.toString());
  }
}
